import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

// ⬇️ not exported, so that one cannot subscribe to the entire store
const usePlateWellStore = create(immer(set => ({
    apiData: {},
    selectedValue: "",
    tabValue: "tab1",
    wellData: [],
    channels: [],
    wellDropDownSelectedData: {},
    plateDropDownSelectedData: [],
    selectedAnanlysisType: "",
    analysisResults: [],
    controlAnalysisOptions: [],
    showGraph: false,
    // ⬇️ separate "namespace" for actions
    actions: {
        setChannelData: (channels) => set(state => {
            state.channels = channels.map(channel => ({
                name: channel,
                visible: true
            }))
        }),
        setWellData: (data) => set(state => { state.wellData = data }),
        setDropDownSelectedData: (data) => set(state => { state.wellDropDownSelectedData = data }),
        setPlateDropDownSelectedData: (data) => set(state => { state.plateDropDownSelectedData = data }),
        setChannelVisibility: (channelName) => set(state => {
            const ch = state.channels.find(item => item?.name === channelName);
            if (ch) {
                ch.visible = !ch.visible
            }
        }),
        setApiData: (data) => set(state => { state.apiData = data }),
        setSelectedValue: (value) => set(state => {
            state.selectedValue = value
        }),
        setSelectedAnanlysisType: (data) => set(state => { state.selectedAnanlysisType = data }),
        setAnalysisResults: (data) => set(state => { state.analysisResults = data }),
        setTabValue: (data) => set(state => { state.tabValue = data }),
        setControlAnalysisOptions: (data) => set(state => { state.controlAnalysisOptions = data }),
        toggleShowGraph: () => set((state) => { state.showGraph = !state.showGraph; }),
    },
})));

// 💡 exported - consumers don't need to write selectors
//atomic selectors 
export const useWellData = () => usePlateWellStore((state) => state.wellData);
export const useDropDownSelectedData = () => usePlateWellStore((state) => state.wellDropDownSelectedData);
export const useChannels = () => usePlateWellStore((state) => state.channels);
export const useShowGraph = () => usePlateWellStore((state) => state.showGraph);
export const usePlateDropDownSelectedData = () => usePlateWellStore((state) => state.plateDropDownSelectedData);
export const useApiData = () => usePlateWellStore((state) => state.apiData);
export const useSelectedValue = () => usePlateWellStore((state) => state.selectedValue);
export const useSelecetedAnalysisType = () => usePlateWellStore((state) => state.selectedAnanlysisType);
export const useAnalysisResults = () => usePlateWellStore((state) => state.analysisResults);
export const useTabValue = () => usePlateWellStore((state) => state.tabValue);
export const useControlAnalysisOptions = () => usePlateWellStore((state) => state.controlAnalysisOptions);
// 🎉 one selector for all our actions, destructure in the components 
export const usePlateWellActions = () => usePlateWellStore((state) => state.actions);